import "core-js/modules/es6.number.constructor";

//
//
//
//
//
//
//
//
//
//
var DataSet = require('@antv/data-set');

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 254
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [{
          item: '示例一',
          count: 40
        }, {
          item: '示例二',
          count: 21
        }, {
          item: '示例三',
          count: 17
        }, {
          item: '示例四',
          count: 13
        }, {
          item: '示例五',
          count: 9
        }];
      }
    }
  },
  data: function data() {
    return {
      scale: [{
        dataKey: 'percent',
        min: 0,
        formatter: '.0%'
      }],
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      },
      labelConfig: ['percent', {
        formatter: function formatter(val, item) {
          return item.point.item + ': ' + val;
        }
      }]
    };
  },
  computed: {
    data: function data() {
      var dv = new DataSet.View().source(this.dataSource); // 计算数据百分比

      dv.transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent'
      });
      return dv.rows;
    }
  }
};